import React from "react";
import { Box, Typography } from "@mui/material";
import CustomerTitleWrapCell from "./CustomerTitleWrapCell";

/** Doc # (blue, left) + title (wraps to the right) — customer quotes / contracts / invoices. */
export default function CustomerNumberTitleStackCell({ number, titleText }) {
  const hasNum = number != null && String(number).trim() !== "";
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "12px",
        minWidth: 0,
        width: "100%",
      }}
    >
      {hasNum ? (
        <Typography
          component="div"
          sx={{
            flexShrink: 0,
            color: "#2563EB",
            fontWeight: 700,
            fontSize: "0.9375rem",
            lineHeight: 1.35,
            whiteSpace: "nowrap",
          }}
        >
          #{String(number).trim()}
        </Typography>
      ) : (
        <Typography
          component="div"
          sx={{ flexShrink: 0, fontSize: "0.9375rem", color: "#9ca3af", lineHeight: 1.35 }}
        >
          —
        </Typography>
      )}
      <Box sx={{ flex: "1 1 0%", minWidth: 0, alignSelf: "stretch" }}>
        <CustomerTitleWrapCell text={titleText} />
      </Box>
    </Box>
  );
}
